import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Config } from '../../config/config';
import { QuyTrinhXuLy } from './quy-trinh-xu-ly';
@Injectable()
export class QuyTrinhXuLyService {
    
    controller:string = 'XL_QuyTrinh';
    constructor(private http: Http) { }
    
    GetList(paging:number,maxSize:number, keyword: string,idLoai:number) {
        let headers = new Headers();
        let currentPage = paging - 1;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetList?offset="+ currentPage+"&pageSize="+ maxSize + "&keyword=" + keyword+"&idLoai="+idLoai, { headers: headers }).map(resp => resp.json());       
    }

    GetListDSQuyTrinhSP(IdCoQuan:number) {
        let headers = new Headers();
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetListDSQuyTrinhSP?IdCoQuan="+ IdCoQuan, { headers: headers }).map(resp => resp.json());       
    }

    GetListDSQuyTrinhSP1(IdCoQuan:number, IdNhomSP: number) {
        let headers = new Headers();
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetListDSQuyTrinhSP1?IdCoQuan="+ IdCoQuan + "&IdNhomSP=" + IdNhomSP, { headers: headers }).map(resp => resp.json());       
    }
    GetListDSQuyTrinhSP2(IdCoQuan:number, IdNhomSP: number, IdNhanVien) {
        let headers = new Headers();
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetListDSQuyTrinhSP2?IdCoQuan="+ IdCoQuan + "&IdNhomSP=" + IdNhomSP + "&IdNhanVien=" + IdNhanVien, { headers: headers }).map(resp => resp.json());       
    }

    GetListDSQuyTrinhNhomSP(IdCoQuan:number) {
        let headers = new Headers();
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetListDSQuyTrinhNhomSP?IdCoQuan="+ IdCoQuan, { headers: headers }).map(resp => resp.json());       
    }

    GetListDSQuyTrinhNhomSP1(IdCoQuan:number, IdNhanVien:number) {
        let headers = new Headers();
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetListDSQuyTrinhNhomSP1?IdCoQuan="+ IdCoQuan + "&IdNhanVien=" + IdNhanVien, { headers: headers }).map(resp => resp.json());       
    }

    GetIdQuyTrinh(IdSanPham:number, NangCap: number) {
        let headers = new Headers();
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetIdQuyTrinh?IdSanPham="+ IdSanPham+"&NangCap="+NangCap, { headers: headers }).map(resp => resp.json());       
    }

    GetListAll() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetList?offset=0&pageSize=1000&keyword=", { headers: headers }).map(resp => resp.json());       
    }
    GetListMucDo(IdQuyTrinh:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetListMucDo?idQuyTrinh=" + IdQuyTrinh, { headers: headers }).map(resp => resp.json());       
    }
    Save(item:QuyTrinhXuLy) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/save', item, { headers: headers }).map(resp => resp.json());
    }
    Delete(item:QuyTrinhXuLy) {
        item.TrangThai = 0;
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/save', item, { headers: headers }).map(resp => resp.json());
    }
    Apply(item:QuyTrinhXuLy) {
        item.TrangThaiApDung = 1;
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/Apply', item, { headers: headers }).map(resp => resp.json());
    }
    CheckYeuCau(IdQuyTrinh:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller+'/CheckYeuCau?idQuyTrinh='+IdQuyTrinh, { headers: headers }).map(resp => resp.json());
    }
    Coppy(IdQuyTrinhNguon:number,IdQuyTrinhDich:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller+'/Coppy?idQuyTrinhNguon='+IdQuyTrinhNguon+'&idQuyTrinhDich='+IdQuyTrinhDich, { headers: headers }).map(resp => resp.json());
    }
    UnApply(item:QuyTrinhXuLy) {
        item.TrangThaiApDung = 0;
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/Apply', item, { headers: headers }).map(resp => resp.json());
    }
    saveMucDoQuyTrinh(IdQuyTrinh:number, mergelist: any) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.post(Config.apiUrl +this.controller+ '/saveQuyTrinhMucDo?idQuyTrinh=' + IdQuyTrinh, JSON.stringify(mergelist), {
            headers: headers
        }).map(resp => resp.json())
    }
    CoppyList(idQuyTrinhNguon: number,IdLoai:number,option:number, listThietBi: number[]) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.post(Config.apiUrl +'XL_QuyTrinh/CoppyList?idQuyTrinhNguon=' + idQuyTrinhNguon+'&idLoai='+IdLoai+'&option='+option, JSON.stringify(listThietBi), {
            headers: headers
        }).map(resp => resp.json())
    }
    luu_anhquytrinh(formData: FormData) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'XL_QuyTrinh/luu_anhquytrinh', formData, { headers: headers }).map(resp => resp.json());
    }    
    ds_anhquytrinh(IdQuyTrinh) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {Id:IdQuyTrinh};
        return this.http.post(Config.apiUrl + 'XL_QuyTrinh/ds_anhquytrinh', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }    
    ds_luongquytrinh() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};
        return this.http.post(Config.apiUrl + 'XL_QuyTrinh/ds_luongquytrinh', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    } 
    ds_luongquytrinhra() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};
        return this.http.post(Config.apiUrl + 'XL_QuyTrinh/ds_luongquytrinhra', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }  
    luu_sanphamquytrinhcoquan(idsanpham, idcoquan, op) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdSanPham:idsanpham,
            IdCoQuan:idcoquan,
            Op:op
        };
        return this.http.post(Config.apiUrl + 'XL_QuyTrinh/luu_sanphamcoquanquytrinh', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_sanphamquytrinhcoquan(idsanpham) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdSanPham:idsanpham
        };
        return this.http.post(Config.apiUrl + 'XL_QuyTrinh/ds_sanphamcoquanquytrinh', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_quytrinhsanphamcon(idbuocthuchien, idquytrinhcon, idBuocQuyTrinhCon) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            Id:idbuocthuchien,
            IdQuyTrinh:idquytrinhcon,
            IdBuocQuyTrinhCon:idBuocQuyTrinhCon
        };
        return this.http.post(Config.apiUrl + 'XL_QuyTrinh/luu_BuocQuyTrinhCon', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_NhomBuocQuyTrinh(dsidbuocketqua) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            dsIdBuocKetQua:dsidbuocketqua         
        };
        return this.http.post(Config.apiUrl + 'XL_Buoc_KetQua/luu_NhomBuocQuyTrinh', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_dieuhuong(idcoquan) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdCoQuan:idcoquan
        };
        return this.http.post(Config.apiUrl + 'XL_QuyTrinh/ds_dieuhuong', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_BuocThoiGianXuLy(idBuoc: number, Op: number) {
        let headers = new Headers();             
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/dsBuocThoiGianXuLy?idBuoc="+ idBuoc+"&Op="+Op, { headers: headers }).map(resp => resp.json());       
    }
    ds_QuyTrinhCon(idBuoc) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdBuoc:idBuoc
        };
        return this.http.post(Config.apiUrl + 'XL_Buoc_KetQua/ds_QuyTrinhCon', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/quy-trinh-xu-ly/quy-trinh-xu-ly.service.ts